import React, { useCallback } from 'react';
import { ChangeHandler, useFormContext } from 'react-hook-form';
import { FormattedMessage, useIntl } from 'react-intl';
import { Heading, TextareaField } from '@printdeal/ui-library';

import {
  dispatchAccountEvent,
  DispatchCategoriesAccount,
} from '../../../../../../helpers/dataLayerHelpers/accountDataLayerHelper';

interface Props {
  ideaDescription: string;
  dispatchEventCategory?: DispatchCategoriesAccount;
}

const DescribeYourIdea = ({
  ideaDescription,
  dispatchEventCategory = 'order_detail_interaction',
}: Props) => {
  const intl = useIntl();
  const {
    register,
    formState: { errors },
  } = useFormContext();

  const fieldName = 'describeYourIdea';
  const fieldRegistration = register(fieldName);

  const handleOnChange:ChangeHandler = useCallback(async (event) => {
    fieldRegistration.onChange(event);

    // Add eventType
    const eventType = event.target.value ? 'fill' : 'empty';
    dispatchAccountEvent(dispatchEventCategory, `file_design_field_interaction - ${eventType}`, { fieldName });
  }, [dispatchEventCategory, fieldRegistration]);

  const handleOnFocus = () => {
    dispatchAccountEvent(dispatchEventCategory, 'file_design_field_interaction - click', { fieldName });
  };

  return (
    <section className="pd-flex pd-flex-col pd-gap-4">
      <Heading size="4">
        <FormattedMessage
          id="account.order.artwork.service.modal.body.step.one.title"
          defaultMessage="Step 1: Clearly describe your idea to us"
        />
      </Heading>
      <p className="pd-mb-3 pd-mt-1">{ideaDescription}</p>
      <TextareaField
        id="describeYourIdea"
        label={intl.formatMessage({
          id: 'account.order.service.fileDesign.modal.body.label',
          defaultMessage: 'Describe your wishes',
        })}
        placeholder={intl.formatMessage({
          id: 'account.order.service.fileDesign.modal.body.placeholder',
          defaultMessage: 'Please describe here your idea',
        })}
        rows={3}
        {...fieldRegistration}
        {...(errors.describeYourIdea
          ? {
            validation: 'error', /* other props if needed */
            validationMessage: intl.formatMessage({
              id: 'account.order.service.fileDesign.modal.body.error',
              defaultMessage: 'You did not enter your wishes.',
            }),
          } : {
          }
        )}
        required
        onBlur={(e) => { handleOnChange(e); }}
        onFocus={handleOnFocus}
      />
    </section>
  );
};

export default DescribeYourIdea;
